let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9WFD8")).then(() => parcelRequire('j8dKe'));